import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from '../../environments/environment'
import { Fia } from '../shared/models/users/fia';

@Injectable({
  providedIn: 'root'
})
export class FiaService {

  env = environment;
  apiUrl = this.env.apiurl + 'platform/fia/';

  constructor(private http: HttpClient, public router: Router) { }

  public FiaApplcation(fia: Fia): Observable<any> {
    return this.http.post<any>(this.apiUrl + 'application', fia, { observe: 'response' })
      .pipe(
        map(res => {
          if (res) {
            if (res.status == 200) {
              return new Fia().deserialize(res.body)
            }
          }
        })
      );
  }
}
